import type { SVGProps } from 'react';
const SvgPersonAddAlt1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#person_add_alt_1_svg__a)">
      <path
        fill="currentColor"
        d="M13 8c0-2.21-1.79-4-4-4S5 5.79 5 8s1.79 4 4 4 4-1.79 4-4Zm2 2v2h3v3h2v-3h3v-2h-3V7h-2v3h-3ZM1 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4Z"
      />
    </g>
    <defs>
      <clipPath id="person_add_alt_1_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPersonAddAlt1;
